import * as apiGetWizardInstances from "@/api/campus/getWizardInstances";

import _ from "lodash";

export default {
  namespaced: true,
  state: {
    loading: false,
    wizardInstances: []
  },
  mutations: {
    gotWizardInstances(state, result) {
      state.wizardInstances = result;
    },

    isLoading(state, loading) {
      state.loading = loading;
    }
  },
  actions: {
    async getWizardInstances({ commit }) {
      commit("isLoading", true);

      const result = await apiGetWizardInstances.get();

      if (result) {
        commit("gotWizardInstances", result);
      }

      commit("isLoading", false);
    },
  },
  getters: {
    wizardInstances: state => {
      return state.wizardInstances;
    }
  }
};
